import { TuiIconTdsIllustrationsCommonLockClockLight } from '@tui-react/proprietary-icons';
import React from 'react';
import { SYSTEM_SCREEN } from 'schema/src/types/poll.generated';
import { resolveLinkUrl } from 'src/utils/location';
import intl from '../../locale';
import ImageComponent from '../Image';
import { NewOverlay } from '../NewOverlay';

export const NewCompletedOverlay: React.FC<{
  isWebview: boolean;
  onClose: VoidFunction;
  overrideData?: SYSTEM_SCREEN;
}> = ({ isWebview, onClose, overrideData }) => {
  const data = overrideData?.data;

  const icon = data?.image ? (
    <ImageComponent image={data.image} />
  ) : (
    <TuiIconTdsIllustrationsCommonLockClockLight iconSize={160} />
  );

  const ctaUrl = resolveLinkUrl(data?.ctaUrl);
  const ctaButton = data?.cta && ctaUrl ? { text: data.cta, href: ctaUrl } : undefined;

  const title = data?.title || intl.formatMessage({ id: 'System.NewIsCompletedSurveyTitle' });

  const description = data?.text || intl.formatMessage({ id: 'System.NewIsCompletedSurveyDescription' });

  const webviewProps = isWebview
    ? {
        onClick: onClose,
        buttonText: intl.formatMessage({ id: 'System.NewIsCompletedSurveyButtonText' }),
      }
    : {};

  return (
    <NewOverlay
      onClose={onClose}
      isWebview={isWebview}
      icon={icon}
      alignContent={data?.alignContent}
      ctaButton={ctaButton}
      title={title}
      description={description}
      {...webviewProps}
    />
  );
};
